const app = (state = {
	app:{},

}, action) => {

	let newState = state;



	switch(action.type) {
		case 'APP_SET_APP':
			newState = {
				...state,
				app:action.payload
			}
		break;

	}

	return newState;
}



export default app;


// WEBPACK FOOTER //
// ./reducers/appReducer.js